import { createApiRef } from '@backstage/core-plugin-api';
import type {
  CheatSheetHint,
  CheatSheetHintInput,
} from '@internal/backstage-plugin-neo4j-cheat-sheet-common';

export type { CheatSheetHint, CheatSheetHintInput };
export {
  CheatSheetHintType,
  CHEAT_SHEET_HINT_TYPES,
  cheatSheetHintsManagePermission,
} from '@internal/backstage-plugin-neo4j-cheat-sheet-common';

export type CheatSheetApi = {
  listHints(): Promise<CheatSheetHint[]>;
  createHint(input: CheatSheetHintInput): Promise<CheatSheetHint>;
  updateHint(id: string, input: CheatSheetHintInput): Promise<CheatSheetHint>;
  deleteHint(id: string): Promise<void>;
};

export const cheatSheetApiRef = createApiRef<CheatSheetApi>({
  id: 'plugin.neo4j-cheat-sheet.service',
});
